export const news = [
  {
    id: "n1",
    title: "年度科幻大片《星渊》定档，三千个特效镜头刷新国产工业水准",
    summary: "历时四年打磨的科幻巨制《星渊》正式官宣定档，导演组首次公开视效制作特辑，近三千个特效镜头引发全网期待。",
    content: [
      "历时四年打磨的科幻巨制《星渊》今日正式官宣定档。片方同步放出了长达六分钟的视效制作特辑，首次完整披露了影片的工业化制作流程。",
      "据主创团队介绍，全片共完成了近三千个特效镜头，其中仅太空站坍塌一场戏就动用了两百余位视效师、历时十一个月完成。制片人表示，团队希望用最真实的物理模拟还原失重环境下的每一次碎裂。",
      "主演阵容方面，影片汇集了实力派演员与新生代面孔。多位演员为角色进行了长达半年的体能与失重训练，部分高危镜头坚持实拍完成。",
      "业内评论认为，《星渊》的出现标志着国产科幻在视觉工业上迈出了扎实的一步。影片将于下月正式登陆全国院线，海外发行同步推进。",
    ],
    category: "film",
    tags: ["科幻", "国产电影", "定档"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20style%20scene%20with%20deep%20red%20and%20dark%20tones%2C%20dramatic%20lighting%2C%20abstract%20space%20station%2C%20editorial%20entertainment%20news%20cover%2C%20high%20contrast%2C%20no%20text&width=800&height=450&seq=news-sci-fi-01&orientation=landscape",
    author: "娱乐前线",
    date: "2026-10-14",
    views: 128600,
    hot: true,
  },
  {
    id: "n2",
    title: "现象级综艺《夜行者》收官，全网话题量突破八十亿",
    summary: "以城市夜归人为主题的纪实综艺《夜行者》温情收官，十二期节目共产生八十亿次话题讨论，被观众称为年度治愈神综。",
    content: [
      "从凌晨四点的早餐摊到深夜零点后的急诊室，《夜行者》用十二期节目记录了这座城市最真实的夜晚。节目收官当晚，相关话题冲上热搜榜首。",
      "节目组透露，为了不打扰被拍摄者，摄制团队大量采用隐蔽机位与自然光拍摄，许多片段都是真实发生的瞬间。总导演在采访中说，他们只是想让大家看见那些默默支撑城市运转的人。",
      "收官特辑中，几位因节目结缘的普通人在镜头前重逢，成为当晚最催泪的画面。网友纷纷留言表示，这档节目让自己重新理解了「生活」两个字。",
      "据悉，节目组已经开始筹备第二季，将镜头转向更多尚未被讲述的行业与城市。",
    ],
    category: "variety",
    tags: ["综艺", "纪实", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=warm%20night%20city%20street%20with%20glowing%20streetlights%20and%20orange%20tones%2C%20documentary%20variety%20show%20cover%2C%20cinematic%20bokeh%2C%20moody%20atmosphere%2C%20no%20text&width=800&height=450&seq=news-variety-02&orientation=landscape",
    author: "综艺观察",
    date: "2026-10-13",
    views: 96420,
    hot: true,
  },
  {
    id: "n3",
    title: "顶流歌手官宣世界巡演，首站门票三分钟售罄",
    summary: "歌手林屿官宣个人第五次世界巡回演唱会，首站门票开售三分钟即告售罄，主办方紧急加场。",
    content: [
      "歌手林屿于今日上午十点官宣全新世界巡回演唱会「回声」，首轮公布包含十二座城市的演出安排。",
      "门票开售仅三分钟，首站北京站全部票档宣告售罄，票务平台一度出现访问高峰。主办方随即宣布为北京站加开一场，并将陆续释放更多城市信息。",
      "据透露，本次巡演将首次采用环绕式舞台设计，观众席与主舞台之间不再设有明显边界。舞美团队表示，希望让每一位观众都成为演出的一部分。",
      "林屿在社交平台留言感谢歌迷支持，并暗示新专辑将随巡演一并公开。",
    ],
    category: "music",
    tags: ["演唱会", "巡演", "音乐"],
    cover: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20red%20and%20orange%20stage%20lights%2C%20silhouette%20of%20performer%2C%20energetic%20music%20event%20photography%2C%20dramatic%20haze%2C%20no%20text&width=800&height=450&seq=news-concert-03&orientation=landscape",
    author: "音乐现场",
    date: "2026-10-13",
    views: 87310,
    hot: true,
  },
  {
    id: "n4",
    title: "院线悬疑片《第七封信》口碑逆袭，上映五日票房破十亿",
    summary: "低成本悬疑片《第七封信》凭借扎实剧本与反转叙事实现票房逆袭，上映五日突破十亿，成为本季度最大黑马。",
    content: [
      "上映首日排片不足百分之八的《第七封信》，凭借观众口碑在五日之内将排片率推高至百分之三十以上，累计票房正式突破十亿。",
      "影片讲述一位退休邮差在整理旧信时，意外卷入一桩跨越二十年的悬案。全片几乎没有大场面，却依靠缜密的叙事结构层层递进。",
      "影评人指出，影片最难得的是把每个配角都写成了有动机、有秘密的完整人物，这让最后的反转显得既意外又合理。",
      "导演在映后交流中表示，剧本前后修改了十七稿，团队更在意观众走出影院后是否还愿意讨论。",
    ],
    category: "film",
    tags: ["悬疑", "票房", "黑马"],
    cover: "https://readdy.ai/api/search-image?query=moody%20detective%20noir%20scene%20with%20stack%20of%20old%20letters%20and%20warm%20desk%20lamp%2C%20deep%20shadows%2C%20red%20accent%2C%20suspense%20film%20style%2C%20no%20text&width=800&height=450&seq=news-suspense-04&orientation=landscape",
    author: "电影速递",
    date: "2026-10-12",
    views: 75240,
    hot: false,
  },
  {
    id: "n5",
    title: "知名演员陈默新剧造型曝光，反差角色引热议",
    summary: "演员陈默在新剧《山与雾》中的造型首次曝光，一改往日形象出演山区教师，网友直呼「完全认不出」。",
    content: [
      "剧组今日发布了一组剧照，演员陈默以朴素造型出演一名山区支教教师，与他一贯的都市精英形象形成强烈反差。",
      "为了贴近角色，陈默提前两个月进山体验生活，减重近十斤。他在采访中说，第一次穿上市集上买来的旧外套时，才真正觉得自己是那个人。",
      "该剧聚焦乡村教育题材，预计于明年第一季度与观众见面。",
    ],
    category: "gossip",
    tags: ["明星", "新剧", "造型"],
    cover: "https://readdy.ai/api/search-image?query=misty%20mountain%20village%20at%20dawn%20with%20soft%20cool%20tones%20and%20warm%20sunrise%20hint%2C%20cinematic%20drama%20still%2C%20atmospheric%20fog%2C%20no%20text&width=800&height=450&seq=news-actor-05&orientation=landscape",
    author: "星闻日报",
    date: "2026-10-12",
    views: 61230,
    hot: false,
  },
  {
    id: "n6",
    title: "音乐节阵容官宣：三十组艺人齐聚，电子舞台首度升级",
    summary: "年度大型音乐节公布完整阵容，三十组中外艺人将连续演出三天，电子舞台首次升级为沉浸式环形结构。",
    content: [
      "主办方今日公布了本届音乐节的完整阵容，共三十组艺人横跨摇滚、民谣、说唱与电子等多种曲风。",
      "今年的电子舞台首次采用沉浸式环形结构，观众可以环绕舞台自由移动，音场经过全新设计。",
      "主办方提醒，音乐节将启用实名制入场与分区管理，建议观众提前规划行程。",
    ],
    category: "music",
    tags: ["音乐节", "阵容", "电子"],
    cover: "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20at%20sunset%20with%20warm%20orange%20sky%20and%20stage%20lights%2C%20energetic%20atmosphere%2C%20wide%20shot%2C%20no%20text&width=800&height=450&seq=news-festival-06&orientation=landscape",
    author: "音乐现场",
    date: "2026-10-11",
    views: 54310,
    hot: false,
  },
  {
    id: "n7",
    title: "《山海奇谭》第二季回归，国漫口碑再攀新高",
    summary: "国漫《山海奇谭》第二季开播首周播放量破两亿，精美的东方美学与叙事深度收获大量好评。",
    content: [
      "阔别两年的国漫《山海奇谭》第二季正式回归，开播首周全网播放量突破两亿。",
      "本季延续了第一季的东方美学风格，在美术、配乐与动作设计上全面升级。制作团队透露，单集最高绘制量超过一万两千张。",
      "不少观众表示，作品的可贵之处在于把神话讲成了关于成长与选择的故事。",
    ],
    category: "film",
    tags: ["国漫", "动画", "口碑"],
    cover: "https://readdy.ai/api/search-image?query=oriental%20mythical%20landscape%20with%20red%20lanterns%2C%20clouds%20and%20ancient%20mountains%2C%20stylized%20animation%20art%2C%20warm%20red%20and%20gold%20palette%2C%20no%20text&width=800&height=450&seq=news-anime-07&orientation=landscape",
    author: "二次元前线",
    date: "2026-10-11",
    views: 49870,
    hot: false,
  },
  {
    id: "n8",
    title: "直播综艺《今晚开麦》改版，观众可实时投票决定剧情",
    summary: "互动直播综艺《今晚开麦》宣布全新改版，观众可在直播中实时投票决定嘉宾走向，开创互动综艺新模式。",
    content: [
      "《今晚开麦》今日宣布全新改版，节目将首次引入实时互动机制，观众可在直播过程中投票决定嘉宾的任务与剧情走向。",
      "制作团队表示，改版后的节目每一期都是「可变的」，没有任何两期完全相同。",
      "业内认为，这种模式对技术稳定性与内容储备都提出了极高要求。",
    ],
    category: "variety",
    tags: ["直播", "互动", "综艺"],
    cover: "https://readdy.ai/api/search-image?query=modern%20tv%20studio%20with%20warm%20red%20and%20orange%20studio%20lights%2C%20live%20broadcast%20variety%20show%20set%2C%20clean%20geometric%20design%2C%20no%20text&width=800&height=450&seq=news-live-08&orientation=landscape",
    author: "综艺观察",
    date: "2026-10-10",
    views: 41220,
    hot: false,
  },
  {
    id: "n9",
    title: "热搜第一：老牌乐队重组巡演，一代人的青春回来了",
    summary: "解散十二年的老牌摇滚乐队宣布重组并启动全国巡演，消息一出迅速登上热搜第一。",
    content: [
      "解散十二年的老牌摇滚乐队今日发布联合声明，宣布正式重组，并将启动名为「不散场」的全国巡演。",
      "消息发布后不到一小时，相关话题便登上热搜榜首，无数乐迷在评论区留言回忆自己的青春。",
      "乐队成员表示，这次重组不是怀旧，而是想告诉大家，有些东西从未真正离开。",
    ],
    category: "hotspot",
    tags: ["热搜", "乐队", "重组"],
    cover: "https://readdy.ai/api/search-image?query=vintage%20rock%20band%20silhouette%20against%20deep%20red%20stage%20backlight%2C%20grainy%20energetic%20concert%20photography%2C%20warm%20tones%2C%20no%20text&width=800&height=450&seq=news-band-09&orientation=landscape",
    author: "热点追踪",
    date: "2026-10-10",
    views: 187650,
    hot: true,
  },
  {
    id: "n10",
    title: "导演江野新作入围国际电影节主竞赛单元",
    summary: "导演江野的新片《长夜将尽》入围国际A类电影节主竞赛单元，成为本届唯一入选的华语影片。",
    content: [
      "国际A类电影节今日公布主竞赛单元入围名单，导演江野的新作《长夜将尽》作为唯一一部华语影片入选。",
      "影片以一座即将拆迁的老城为背景，讲述了三代人的离别与和解。",
      "江野表示，能把家乡的故事带到国际舞台，是他做电影以来最珍惜的时刻。",
    ],
    category: "film",
    tags: ["电影节", "入围", "华语"],
    cover: "https://readdy.ai/api/search-image?query=old%20town%20street%20at%20dusk%20with%20warm%20amber%20light%20and%20soft%20mist%2C%20cinematic%20art%20house%20film%20still%2C%20melancholic%20tone%2C%20no%20text&width=800&height=450&seq=news-filmfest-10&orientation=landscape",
    author: "电影速递",
    date: "2026-10-09",
    views: 38910,
    hot: false,
  },
  {
    id: "n11",
    title: "演员苏晚回应争议，工作室发布完整时间线",
    summary: "针对近日的网络争议，演员苏晚工作室发布完整时间线说明，苏晚本人转发并表示「问心无愧」。",
    content: [
      "近日围绕演员苏晚的一则不实传闻在网络上发酵，其工作室今日发布长图，以完整时间线还原事件经过。",
      "苏晚本人转发了该说明，并写道：「把时间留给作品，把真相留给时间。」",
      "多家媒体呼吁网友理性看待网络信息，避免以讹传讹。",
    ],
    category: "gossip",
    tags: ["争议", "回应", "明星"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20clean%20studio%20interview%20setting%20with%20warm%20neutral%20tones%20and%20soft%20red%20accent%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=450&seq=news-response-11&orientation=landscape",
    author: "星闻日报",
    date: "2026-10-09",
    views: 72140,
    hot: false,
  },
  {
    id: "n12",
    title: "跨年晚会筹备启动，多家平台公布首批嘉宾",
    summary: "多家视频平台陆续公布跨年晚会的首批嘉宾阵容，科技感舞台与沉浸式互动成为今年亮点。",
    content: [
      "距离跨年还有两个多月，多家平台已陆续启动跨年晚会的筹备工作，并公布了首批嘉宾阵容。",
      "据悉，今年的舞台将大量运用实时虚拟制作技术，观众可通过互动端参与节目呈现。",
      "各家平台表示，将在内容与技术上展开差异化竞争。",
    ],
    category: "variety",
    tags: ["跨年", "晚会", "嘉宾"],
    cover: "https://readdy.ai/api/search-image?query=festive%20new%20year%20gala%20stage%20with%20warm%20red%20and%20gold%20lights%2C%20confetti%20and%20celebration%20atmosphere%2C%20wide%20shot%2C%20no%20text&width=800&height=450&seq=news-gala-12&orientation=landscape",
    author: "综艺观察",
    date: "2026-10-08",
    views: 33450,
    hot: false,
  },
];